<template>
  <div class="trigger trigger-border">
    <label>{{ $t('configuracao-dos-gatilhos-dos-limites') }}</label>
    <span class="flex-row justify-around">
      <div v-if="!isRta" class="trigger-border set-values">
        <span class="element-overlap" :title="triggerInfo.VLV.title">
          <b-form-checkbox id="limit-value" v-model="vlvActive" @change="this.sendVLV" class="trigger-checkBox"
            name="limit-value" value=true>
            {{ $t('limite-de-valor') }} 
          </b-form-checkbox>
          <b-icon v-if="!show" @click="() => this.showInfo(triggerInfo.VLV.description)" class="question-icon"
            icon="question-circle-fill" aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-1'), }" class="question-icon"
            icon="question-circle-fill" aria-hidden="true">
          </b-icon>
        </span>

        <div class="flex-row limit-value">
          <div class="flex-row">
            <b-form-checkbox name="checkbox-1" v-model="minActive" @change="this.sendVLV" class="trigger-checkBox"
              value=true>{{ $t('limite-minimo') }}</b-form-checkbox>
            <b-form-input type="number" size="lg" v-model="minValue" @keyup="this.sendVLV" @change="this.sendVLV"
              placeholder="0,00"></b-form-input>
          </div>
          <div class="flex-row ml-2">
            <b-form-checkbox name="checkbox-2" v-model="maxActive" @change="this.sendVLV" class="trigger-checkBox"
              value=true>{{ $t('limite-maximo') }}</b-form-checkbox>
            <b-form-input type="number" size="lg" v-model="maxValue" @keyup="this.sendVLV" @change="this.sendVLV"
              placeholder="0,00"></b-form-input>
          </div>
        </div>
      </div>

      <div class="trigger-border set-values">
        <span :title="triggerInfo.VFR.title" class="element-overlap">
          <b-form-checkbox id="checkbox-3" v-model="vfrActive" @change="this.sendVFR" class="trigger-checkBox"
            name="checkbox-3" value=true>
            {{ $t('analises-fora-da-meta') }} </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VFR.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-2'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>

        <div class="flex-row justify-between trigger-box align-items-center" style="gap: 1rem;">
          <span class="flex-row align-items-center" style="gap: 2px;">
            <label for="unit-frequency">{{ $t('nao-conformidades') }}</label>
            <b-form-input type="number" size="lg" v-model="unconformities" @keyup="this.sendVFR" @change="this.sendVFR" 
              id="unit-frequency" placeholder="1" @input="handleInput('unconformities', $event)" 
              style="width: 60px;" min="1">
            </b-form-input>
          </span>

          <span class="flex-row align-items-center" style="gap: 1px;">
            <b-form-checkbox name="vfr-min-checkbox" v-model="vfrMinActive" @change="sendVFR" class="trigger-checkBox"
              value=true></b-form-checkbox>
            <label for="vfr-min">{{ $t('limite-minimo') }}</label>
            <b-form-input type="number" size="lg" id="vfr-min" v-model="vfrMinValue" @keyup="sendVFR" @change="sendVFR"
              placeholder="0" style="width: 60px;" :disabled="!vfrMinActive" />
          </span>

          <span class="flex-row align-items-center" style="gap: 2px;">
            <b-form-checkbox name="vfr-max-checkbox" v-model="vfrMaxActive" @change="sendVFR" class="trigger-checkBox"
              value=true></b-form-checkbox>
            <label for="vfr-max">{{ $t('limite-maximo') }}</label>
            <b-form-input type="number" size="lg" id="vfr-max" v-model="vfrMaxValue" @keyup="sendVFR" @change="sendVFR"
              placeholder="9999" style="width: 60px;" :disabled="!vfrMaxActive" />
          </span>
        </div>
      </div>

      <div v-if="!isRta" class="trigger-border set-values mt-2">
        <span :title="triggerInfo.VLT.title" class="element-overlap">
          <b-form-checkbox id="checkbox-4" v-model="vltActive" @change="this.sendVLT" class="trigger-checkBox"
            name="checkbox-4" value=true>
            {{ $t('tempo-sem-atingir-meta') }} </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VLT.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-3'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>

        <div class="limit-value2">
          <span class="flex-row">
            <label for="minute-interval">{{ $t('intervalo') }}</label>
            <b-form-input type="number" size="lg" id="minute-interval" v-model="minutes" @keyup="this.sendVLT" @change="this.sendVLT"
              placeholder="1" @input="handleInput('minutes', $event)" min="1">
            </b-form-input>
            <label v-if="!show" for="minute-interval">{{ $t('minutos') }}</label>
            <label v-if="show" for="minute-interval">{{ $t('days') }}</label>
          </span>
        </div>
      </div>

    </span>
  </div>
</template>

<script>
import MediatorTrigger from "../tools/MediatorTrigger";

export default {
  name: "TriggerLimitValue",
  props: ["triggerInfo", "reset", "triggerSelected", "show", "isRta"],
  inject: ["showInfo", "showResponsibles"],
  data() {
    return {
      vlvActive: false,
      minActive: false,
      minValue: 0,
      maxActive: false,
      maxValue: 0,

      vfrActive: false,
      unconformities: 1,
      vfrMinActive: false,
      vfrMinValue: 0,
      vfrMaxActive: false,
      vfrMaxValue: 100,

      vltActive: false,
      minutes: 1,
      updating: false,

      daysConverted: 0
    }
  },
  watch: {
    reset() {
      this.resetForm();
    },
  },

  methods: {
    loadForm(value) {
      if (!value.VLV) return
      this.updating = true;

      this.vlvActive = value.VLV.active;
      if (value.VLV.configurationJSON) {
        let configurationJSON = JSON.parse(value.VLV.configurationJSON)
        this.minActive = configurationJSON.minActive;
        this.minValue = configurationJSON.minValue;
        this.maxActive = configurationJSON.maxActive;
        this.maxValue = configurationJSON.maxValue;
      }

      this.vfrActive = value.VFR.active;
      if (value.VFR.configurationJSON) {
        let configurationJSON = JSON.parse(value.VFR.configurationJSON)
        this.unconformities = configurationJSON.unconformities;
        this.vfrMinActive = configurationJSON.minActive;
        this.vfrMinValue = configurationJSON.minValue;
        this.vfrMaxActive = configurationJSON.maxActive;
        this.vfrMaxValue = configurationJSON.maxValue;
      }

      this.vltActive = value.VLT.active;
      if (value.VLT.configurationJSON) {
        let configurationJSON = JSON.parse(value.VLT.configurationJSON)
        if(this.show){
          this.minutes = configurationJSON.minutes/1440;
        }else{
          this.minutes = configurationJSON.minutes;
        }
      }
    },

    sendVLV() {
      MediatorTrigger.notify({
        active: this.vlvActive,
        minActive: this.minActive,
        minValue: this.minValue,
        maxActive: this.maxActive,
        maxValue: this.maxValue,
      }, "setVLV")
    },

    sendVFR() {
      MediatorTrigger.notify({
        active: this.vfrActive,
        unconformities: this.unconformities,
        minActive: this.vfrMinActive,
        minValue: this.vfrMinValue,
        maxActive: this.vfrMaxActive,
        maxValue: this.vfrMaxValue
      }, "setVFR");
    },

    sendVLT() {
      if (this.show) 
      {
        this.daysConverted = (this.minutes * 1440)
        
        MediatorTrigger.notify({
          active: this.vltActive,
          minutes: this.daysConverted
        }, "setVLT")
      } else 
      {
        MediatorTrigger.notify({
          active: this.vltActive,
          minutes: this.minutes
        }, "setVLT")
      }
    },

    resetForm() {
      this.vlvActive = false;
      this.minActive = false;
      this.minValue = 0;
      this.maxActive = false;
      this.maxValue = 0;
      this.vfrActive = false;
      this.unconformities = 4;
      this.vfrMinActive = false;
      this.vfrMinValue = 0;
      this.vfrMaxActive = false;
      this.vfrMaxValue = 100;
      this.vltActive = false;
      
      if (this.show) 
      {
        this.minutes = 1;
      } else 
      {
        this.minutes = 10;
      }

      this.daysConverted = 0;
    },

    handleInput(prop, event) {
      let cleanedValue = event.replace(/\D/g, '');
      if (prop == 'unconformities')
        this.unconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else
        this.minutes = cleanedValue !== '' ? parseInt(cleanedValue) : null;
    }
  },

  mounted() {
    console.log("TriggerValueLimit - isRta:", this.isRta);
    
    if (this.show) 
    {
      this.minutes = 1
    }

    MediatorTrigger.notify(this, "initTriggerValueLimit")
  },
}
</script>

<style scoped src="../style.css"></style>